import React from 'react';

export const SkeletonRow = ({ cols = 4 }) => (
  <div className="flex items-center gap-3 px-3 py-3 border-b border-white/5" data-testid="loading-skeleton">
    {Array.from({ length: cols }).map((_, i) => (
      <div key={i} className="skel h-4 rounded-md" style={{ width: i === 0 ? '30%' : `${20 + ((i * 7) % 25)}%` }} />
    ))}
  </div>
);

export const SkeletonCard = ({ h = 120 }) => (
  <div className="skel rounded-lg" style={{ height: h }} data-testid="loading-skeleton" />
);
